import { request } from '../lib/request';

const faulttypeApi = request({
  baseURL: process.env.REACT_APP_BASE_API + 'fault-type/'
});

export const getFaultType = async () => {
    return await faulttypeApi.get('search-list');
}
  